import { render, staticRenderFns } from "./ControlPanelGroupHeader.vue?vue&type=template&id=07b8919a"
import script from "./ControlPanelGroupHeader.vue?vue&type=script&lang=ts"
export * from "./ControlPanelGroupHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZAvatar: require('/app/components/zeal/ZAvatar/ZAvatar.vue').default,ScimIconWrapper: require('/app/components/ControlPanel/ScimIconWrapper.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ControlPanelAddTeamToGroupModal: require('/app/components/ControlPanel/Modals/ControlPanelAddTeamToGroupModal.vue').default,ControlPanelGroupInviteModal: require('/app/components/ControlPanel/Modals/ControlPanelGroupInviteModal.vue').default,ControlPanelEditGroupModal: require('/app/components/ControlPanel/Modals/ControlPanelEditGroupModal.vue').default,DeleteGroupButton: require('/app/components/ControlPanel/DeleteGroupButton.vue').default})
